import './App.css';
import AppRoutes from './AppRoutes.jsx';
import "react-quill/dist/quill.snow.css";

const App = () => {
  return (
      <div>
     <AppRoutes/>
      </div>

  );
};

export default App; 
